
import axios from "axios";
import { CuentasCobrarModel, NotaCuentasCobrarModel } from "../../pages/cobranza/cuentas_por_cobrar/models/CuentasCobrarModel";
import { SelectFormat } from "../../../_metronic/helpers/models/GenericModel";
import { UserModel } from "../../modules/auth/models/UserModel";
const API_URL = process.env.REACT_APP_API;


export const obtenerCuentasPorEtapa = async (filter: any) => {
  try {

    const { campo_id, valor } = filter;
    const data_filter = {
        campo_id, valor
    }
    const response = await axios.post(`${API_URL}forma/pago/ordenes/cobro/all/filtros`, data_filter);
    const cuentas = response.data.doc.data;
    const cuentasPorEtapa = cuentas.map((item: any) => {
      const tarjetas = item.items.map((element: any) => {
        return {
          ...element,
          draggable: item.code === "PAG" ? false : true,
          laneId: element.etapa.id,
        };
      })
      return {
        id: item.code,
        etapa_id: item.etapaId,
        title: item.nombre,
        code: item.code,
        color_etapa: item.color,
        monto_total_mxn: item.monto_total_mxn,
        monto_total_usd: item.monto_total_usd,
        label: 1,
        style: { width: 380 },
        currentPage: 1,
        disallowAddingCard: true,
        cards: tarjetas,
      }
    });
    return {
      cuentas,
      cuentasPorEtapa
    };
  } catch (error) {
    console.error("Error al obtener las cuentas por cobrar:", error);
    throw error;
  }
};

export async function actualizarEtapaOrdenCobro(values: any) {
  try {
    const { id, etapaCode } = values;
    let data = {
      orden_cobro_id: id,
      etapa_code: etapaCode
    }
    const response = await axios.put(`${API_URL}forma/pago/ordenes/cobro/cambiar/etapa`, data);
    return response;
  } catch (error) {
    console.error("Error al cambiar la etapa:", error);
    throw error;
  }
}

export async function obtenerCamposFiltroCobro() {
  try {

    const response = await axios.get(`${API_URL}catalogs/campos/TBL_ORD_COB`);
    const data = response.data.doc.data;
    return data;

  } catch (error) {
    console.error("Error al obtener los campos a filtrar:", error);
    throw error;
  }
}

export async function obtenerDatosFiltrosCobro(code: string) {
  try{

    let response;
    let data;
    let res;
    let selectOptions;

    switch (code) {
        case 'ORD_COB_NOM':
            response = await axios.get(`${API_URL}forma/pago/ordenes/cobro/all`);
            res = response.data.doc.data;
            selectOptions = res.map((option: any) => ({
              value: option.id,
              label: option.nombre,
            }));
            data = selectOptions;
            break;
        case 'ORD_COB_ETP':
            response = await axios.get(`${API_URL}catalogs/EORD_COB`);
            res = response.data.doc.data.rows;
            selectOptions = res.map((option: any) => ({
              value: option.id,
              label: option.name,
            }));
            data = selectOptions;
            break;
        case 'ORD_COB_STS':
            response = await axios.get(`${API_URL}catalogs/STS_ORD_COB/`);
            res = response.data.doc.data.rows;
            selectOptions = res.map((option: any) => ({
              value: option.id,
              label: option.name,
            }));
            data = selectOptions;
            break;
        case 'ORD_COB_USER':
            response = await axios.get(`${API_URL}catalogos/vendedores/list/comerciales`);
            res = response.data.doc.data.rows;
            selectOptions = res.map((option: any) => ({
              value: option.id,
              label: `${option.nombre} ${option.apellido_paterno}`,
            }));
            data = selectOptions;
            break;
        case 'ORD_COB_TIPO_PAGO':
          response = await axios.get(`${API_URL}catalogs/TIPO_PAGO/`);
          res = response.data.doc.data.rows;
          selectOptions = res.map((option: any) => ({
            value: option.id,
            label: option.name,
          }));
          data = selectOptions;
            break;
        case 'ORD_COB_COBRADOR':
          response = await axios.get(`${API_URL}users/role/COB`);
          res = response.data.doc.data;
          selectOptions = res.map((option: any) => ({
            value: option.id,
            label: `${option.first_name} ${option.father_last_name}`,
          }));
          data = selectOptions;
            break;
        default:  
            break;
    }
    return data;

  } catch (error) {
    console.error("Error al obtener los campos a filtrar:", error);
    throw error;
  }

}

export async function actualizarNombreEtapaOC(code_catalogo: string, body: any) {
  try {
    const { id, code, name, order } = body;
    let data = {
      code: code,
      name: name,
    };
    let response = await axios.put(`${API_URL}catalogs/${id}`, data);
    return response;
    
  } catch (error) {
    console.error("Error al cambiar nombre de la etapa:", error);
    throw error;
  }
}



export async function obtenerOrdenPorID(id_orden: number) {

  try {
    let response = await axios.get(`${API_URL}forma/pago/ordenes/cobro/${id_orden}`);
    let {  id, nombre, telefono, email, concepto_cobro, no_cobro, cobro, folio, fecha_facturacion, fecha_vencimiento,
      created_at, tipoProyecto, unidadMoneda, cuenta, subcuenta, vendedorAsignado, contacto, tipoPago, etapa, estatus, cotizacion, formaPago, cobrador,
    proyecto } = response.data.doc.data;
    
    const initialCuentasCobrar: CuentasCobrarModel = {
          id: id,
          nombre: nombre,
          telefono: telefono,
          email: email,
          concepto_cobro: concepto_cobro,
          no_cobro: no_cobro,
          cobro: cobro,
          folio: folio,
          fecha_facturacion: fecha_facturacion ? new Date(fecha_facturacion).toISOString().split("T")[0]: null,
          fecha_vencimiento: fecha_vencimiento ? new Date(fecha_vencimiento).toISOString().split("T")[0]: null,
          created_at: new Date(created_at).toISOString().split("T")[0],
          tipoProyecto: {
            id: tipoProyecto?.id > 0 ? tipoProyecto?.id : 0,
        name: tipoProyecto?.id > 0 ? tipoProyecto?.name : '',
         code: tipoProyecto?.id > 0 ? tipoProyecto?.code : '',
          },
          unidadMoneda: {
            id: unidadMoneda?.id > 0 ? unidadMoneda?.id : 0,
        name: unidadMoneda?.id > 0 ? unidadMoneda?.name : '',
         code: unidadMoneda?.id > 0 ? unidadMoneda?.code : '',
          },
          cuenta: {
            id: cuenta?.id > 0 ? cuenta?.id : 0,
            nombre: cuenta?.id > 0 ? cuenta?.nombre : '',
          },
          subcuenta: {
            id: subcuenta?.id > 0 ? subcuenta?.id : 0,
            nombre: subcuenta?.id > 0 ? subcuenta?.nombre : '',
          },
          vendedorAsignado: {
            id: vendedorAsignado?.id > 0 ? vendedorAsignado?.id : 0,
            nombre: vendedorAsignado?.id > 0 ? vendedorAsignado?.nombre : '',
            apellido_paterno: vendedorAsignado?.id > 0 ? vendedorAsignado?.apellido_paterno : '',
            apellido_materno: vendedorAsignado?.id > 0 ? vendedorAsignado?.apellido_materno : '',
            email: vendedorAsignado?.id > 0 ? vendedorAsignado?.email : '',
            telefono: vendedorAsignado?.id > 0 ? vendedorAsignado?.telefono : '',
            user: {
              id: vendedorAsignado?.user?.id > 0 ? vendedorAsignado?.user?.id : 0,
              profile_photo: vendedorAsignado?.user?.id > 0 ? vendedorAsignado?.user?.profile_photo : '',
            },
          },
          cobrador: {
            id: (cobrador && cobrador.id > 0) ? cobrador.id : 0,
            first_name: (cobrador && cobrador.id > 0) ? cobrador.first_name : '',
            father_last_name: (cobrador && cobrador.id > 0) ? cobrador.father_last_name : '',
            mother_last_name:( cobrador && cobrador.id > 0) ? cobrador.mother_last_name : '',
            profile_photo: (cobrador && cobrador.id > 0) ? cobrador.profile_photo : '',
          },
          contacto: {
            id: contacto?.id > 0 ? contacto?.id : 0,
            nombre: contacto?.id > 0 ? contacto?.nombre : '',
            apellido_paterno: contacto?.id > 0 ? contacto?.apellido_paterno : '',
            apellido_materno: contacto?.id > 0 ? contacto?.apellido_materno : '',
            email: contacto?.id > 0 ? contacto?.email : '',
            telefono: contacto?.id > 0 ? contacto?.telefono : '',
          },
          tipoPago: {
            id: tipoPago?.id > 0 ? tipoPago?.id : 0,
            name: tipoPago?.id > 0 ? tipoPago?.name : '',
             code: tipoPago?.id > 0 ? tipoPago?.code : '',
          },
          etapa: {
            id: etapa?.id > 0 ? etapa?.id : 0,
            name: etapa?.id > 0 ? etapa?.name : '',
             code: etapa?.id > 0 ? etapa?.code : '',
          },
          estatus: {
            id: estatus?.id > 0 ? estatus?.id : 0,
            name: estatus?.id > 0 ? estatus?.name : '',
             code: estatus?.id > 0 ? estatus?.code : '',
          },
          cotizacion: {
            id: cotizacion?.id > 0 ? cotizacion?.id : 0,
            folio: cotizacion?.id > 0 ? cotizacion?.folio : '',
          },
          formaPago:{
            id: formaPago?.id > 0 ? formaPago?.id : 0,
            dias_pago: formaPago?.id > 0 ? formaPago?.dias_pago: 0,
          },
          proyecto:{
            id: proyecto?.id > 0 ? proyecto?.id : 0,
            nombre: proyecto?.id > 0 ? proyecto?.nombre: '',
          },
          
        };
    return initialCuentasCobrar;
  } catch (error) {
    console.error("Error en la petición:", error);
    throw error; 
  }
}


export async function serviceEditarOrdenCobro(
  { 
    id, fecha_facturacion, fecha_vencimiento, folio, estatus, cobrador
  } : CuentasCobrarModel) {
    try {
      let data = {
        folio: folio,
        fecha_facturacion: fecha_facturacion,
        fecha_vencimiento: fecha_vencimiento,
        status_id: estatus.id,
        cobrador_id: cobrador.id
      }
      const response = await axios.put(`${API_URL}forma/pago/ordenes/cobro/${id}`,
        data
      );
      return response;
  
    } catch (error) {
      console.error("Error al obtener los campos a filtrar:", error);
      throw error;
    }

}


export async function getNotesByOrdenCobroId(id: number) {
  
  try {
    const response = await axios.get(
      `${API_URL}ordenes/cobro/notas/all/${id}`
    );
    const data = response.data.doc.data;
    return data;
  } catch (error) {
    console.error("Error al obtener las notas:", error);
    throw error;
  }

  
}

export async function insertNoteCuentasCobrar(note: any, id: number) {

  try {
    const response = await axios.post(`${API_URL}ordenes/cobro/notas/`, {
      nombre: note.nombre,
      descripcion: note.descripcion,
      orden_cobro_id: Number(id),
    });
    return response.data;
  } catch (error) {
    console.error("Error al agregar la nota:", error);
    throw error;
  }
}

export const getNoteCuentasCobrarByID = async (id: string) => {
  try {
    const response = await axios.get(`${API_URL}ordenes/cobro/notas/${id}`);
    let note = response.data.doc.data;
    note = {
      ...note,
      cuenta_cobrar_id: note.ordenCobro?.id | 0,
      created_at: note.created_at
        ? new Date(note.created_at).toISOString().split("T")[0]
        : new Date().toISOString().split("T")[0],
      updated_at: note.updated_at
        ? new Date(note.updated_at).toISOString().split("T")[0]
        : new Date().toISOString().split("T")[0],
    };
    return note;
  } catch (error) {
    console.error("Error al obtener la nota:", error);
    throw error;
  }
  
};
export async function updateNoteCuentasCobrar(note: NotaCuentasCobrarModel) {
  try {
    const { id, nombre, descripcion } = note;
    const response = await axios.put(`${API_URL}ordenes/cobro/notas/${id}`, {
      nombre: nombre,
      descripcion: descripcion,
    });
    return response;
  } catch (error) {
    console.error("Error al actualizar la nota:", error);
    throw error;
  } 
}


export const uploadFileToCuentasCobrar = async (file: any, id: string) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("orden_cobro_id", id);
    const response = await axios.post(
      `${API_URL}ordenes/cobro/documentos`,
      formData
    );
    return response;
  } catch (error) {
    console.error("Error al subir el documento:", error);
    throw error;
  }
};
export const removeFileOfCuentasCobrar = async (id: number) => {
  try {
    const response = await axios.delete(
      `${API_URL}ordenes/cobro/documentos/${id}`
    );
    return response;
  } catch (error) {
    console.error("Error al eliminar el documento:", error);
    throw error;
  }
};

export async function getDocumentsByCuentasCobrarId(id: number) {

  try {

    const response = await axios.get(`${API_URL}ordenes/cobro/documentos/all/${id}`);
    const data = response.data.doc.data;
    return data;

  } catch (error) {
    console.error("Error al obtener los documentos:", error);
    throw error;
  }

}

export async function getHistorialCuentasCobrar(search: string, id: string) {

  try {
   
    const response = await axios.get(`${API_URL}ordenes/cobro/historial/all/${id}`);
    const data = response.data.doc.data;
    return data;

  } catch (error) {
    console.error("Error al obtener el historial:", error);
    throw error;
  } 
  
}
export async function createHistoryMessageCuentasCobrar(message: string, id: number) {

  try {
   
    const response = await axios.post(
      `${API_URL}ordenes/cobro/historial/comment`,
      {
        orden_cobro_id: id,
        comentario: message,
      }
    );
    return response;

  } catch (error) {
    console.error("Error al obtener el historial:", error);
    throw error;
  } 
}


export async function getUsersRoleCob() {
  const response = await axios.get(`${API_URL}users/role/COB`);
  const data = response.data.doc.data;
  let select : SelectFormat[] = [];
  data.forEach((user: UserModel) => {
      const selectCustom = {
        id: Number(user.id),
        value: user.id.toString(),
        label: `${user.first_name} ${user.father_last_name} ${user?.mother_last_name}`,
        data: user
      };
      select.push(selectCustom);
  });
  return select;
}